module.exports = __webpack_public_path__ + "img/field-5.f8aa8ef6.svg";